export default __webpack_public_path__ + "static/media/ad2.34be6a54.mp4";